import { stampcardStore } from "./store";
import type { StampcardState, StampcardStore } from "./store.types";

const storeSelector = (state: StampcardStore): StampcardState => state;

function getStampcardState(): StampcardState {
  return storeSelector(stampcardStore.getState());
}

export { getStampcardState };
